import api from './api';

// MPG Assist — chat de suporte com IA. Endpoints de back-end/.../assist/AssistController.
export const assist = {
    // Abre a conversa do usuário ou devolve a que já estava aberta, com o
    // histórico. Idempotente de propósito: chamado toda vez que o widget abre.
    abrir: (corpo) => api.post('/assist/conversas', corpo).then(r => r.data),
    obter: (id) => api.get(`/assist/conversas/${id}`).then(r => r.data),
    enviarMensagem: (id, conteudo) => api.post(`/assist/conversas/${id}/mensagens`, { conteudo }).then(r => r.data),
    solicitarAtendente: (id, motivo) => api.post(`/assist/conversas/${id}/atendente`, motivo ? { motivo } : undefined).then(r => r.data),
    resolver: (id) => api.post(`/assist/conversas/${id}/resolver`).then(r => r.data),
    encerrar: (id) => api.post(`/assist/conversas/${id}/encerrar`).then(r => r.data),
    // { url } — nulo quando a instalação não configurou o número do suporte.
    whatsapp: (id) => api.get(`/assist/conversas/${id}/whatsapp`).then(r => r.data),
};

// Painel de atendimento humano (fase 7, ASSIST_ATENDER). Endpoints de
// back-end/.../assist/AtendimentoAssistController — sem recorte de dono.
export const atendimentoAssist = {
    painel: () => api.get('/assist/atendimento').then(r => r.data),
    obter: (id) => api.get(`/assist/atendimento/${id}`).then(r => r.data),
    assumir: (id) => api.post(`/assist/atendimento/${id}/assumir`).then(r => r.data),
    responder: (id, conteudo) => api.post(`/assist/atendimento/${id}/mensagens`, { conteudo }).then(r => r.data),
    encerrar: (id) => api.post(`/assist/atendimento/${id}/encerrar`).then(r => r.data),
};

// Respostas prontas do atendimento humano (issue #448, ASSIST_ATENDER).
// Endpoints de back-end/.../assist/AssistRespostaProntaController.
export const respostasProntasAssist = {
    listar: () => api.get('/assist/respostas-prontas').then(r => r.data),
    criar: (corpo) => api.post('/assist/respostas-prontas', corpo).then(r => r.data),
    atualizar: (id, corpo) => api.put(`/assist/respostas-prontas/${id}`, corpo).then(r => r.data),
    excluir: (id) => api.delete(`/assist/respostas-prontas/${id}`).then(r => r.data),
};
